export const ERRO_PROPOSTA_EXCLUIDA = 'Caro parceiro, este rascunho foi excluído. Por favor, inicie uma nova venda.'
